import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MuiModule } from '@move/ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-unexpected-navigation-error',
  templateUrl: './unexpected-navigation-error.component.html',
  styleUrls: ['./unexpected-navigation-error.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    MuiModule
  ]
})
export class UnexpectedNavigationErrorComponent {

  readonly showReload: boolean;

  constructor(private _router: Router) {
    // Show home button if the user navigated to this page directly
    this.showReload = this._router.routerState.snapshot.url !== location.pathname;
  }

  reload(): void {
    location.reload();
  }
}
